import React from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";

function Users() {
  return (
    <Box
      sx={{
        margin: "100px",
      }}
    >
      <MiniDrawer sx={{ margin: "150px" }} />
      <h1>users</h1>
    </Box>
  );
}

export default Users;
